import { render, staticRenderFns } from "./WorkflowImport.vue?vue&type=template&id=2f10a0e6"
import script from "./WorkflowImport.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowImport.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports